module.exports = __webpack_public_path__ + "img/jidian_yitihuajieneng.f78822d3.png";